var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"top mb-150"},[_c('CompanyTop')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }